import React from 'react';

import { EmailIcon } from 'assets/images/index';
import FormBody from 'components/FormBody/index';
import FormHeader from 'components/FormHeader/index';
import { PhoneIcon } from 'components/Icons/index';
import { EmployeeInformation } from 'enums/EmployeeInformation';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';
import { Theme } from 'enums/Theme';
import { useAppSelector } from 'hooks/useAppSelector';
import styles from 'pages/Dashboard/FAQ/FAQ.module.scss';

const FAQ = () => {
  const consultant = useAppSelector((state) => state.application?.[LoanInformationVariables.AssignedConsultant]);

  const renderConsultantInformation = (dataType: EmployeeInformation, value: string) => {
    return (
      <div className={styles.consultInfoRow}>
        {dataType === EmployeeInformation.Phone ? (
          <PhoneIcon className={styles.icon} />
        ) : (
          <EmailIcon className={styles.icon} />
        )}
        <div>{value}</div>
      </div>
    );
  };

  return (
    <>
      {consultant && (
        <FormHeader classNameHeader={styles.formHeader} isBorderRounded={false} theme={Theme.Dark}>
          {consultant.name && consultant.position && (
            <div className={styles.consultName}>{consultant.name + ', ' + consultant.position}</div>
          )}
          {consultant.phone && renderConsultantInformation(EmployeeInformation.Phone, consultant.phone)}
          {consultant.email && renderConsultantInformation(EmployeeInformation.Email, consultant.email)}
        </FormHeader>
      )}
      <FormBody formBodyClassName={styles.formBody}>
        <h1 className={styles.faqHeader}>FAQ's</h1>
        <div className={styles.faq}>
          <p>Did HFS receive my uploaded documents?</p>
          <ul>
            <li>
              If you see “Received” after you upload your loan documents, this means your documents were uploaded
              successfully and HFS is reviewing them.
            </li>
            <li>If you see “Completed” that means HFS has accepted those uploads.</li>
          </ul>
        </div>
        <div className={styles.faq}>
          <p>Why are you requesting a Voided Check?</p>
          <ul>
            <li>A voided check is used to fund the consumer a lump sum of the loan proceeds.</li>
          </ul>
        </div>
        <div className={styles.faq}>
          <p>What if I do not have a Voided Check?</p>
          <ul>
            <li>
              If you do not have physical checks available, please logon to your online banking. We will need you to
              upload screenshot(s) from your online banking portal that show; Your Name, Bank Name, Account # and
              Routing #.
            </li>
          </ul>
        </div>
        <div className={styles.faq}>
          <p>I am not sure if my contract / estimate is acceptable.</p>
          <ul>
            <li>
              HFS can accept bids, estimates, or contracts that your contractor(s) have provided to you. Whatever you
              chose to upload, it must bear your signature on it. These do NOT have to be final/binding home
              improvements contracts, as most consumers end up providing us with estimates. You can always make changes
              to your project as we just need these document(s) as a loan guideline requirement.
            </li>
            <li>
              Additionally, you have the option to finance as much as 20% more than the total cost of the scope of work,
              should you qualify. If you need to increase your loan, please contact your initial loan consultant.
            </li>
          </ul>
        </div>
        <div className={styles.faq}>
          <p>Can I change my loan terms?</p>
          <ul>
            <li>
              If at any time prior to your loan funding you wish to alter your loan amount or term, please contact your
              personal loan consultant. Please note, that a requested change in loan term may affect your current
              interest rate.
            </li>
          </ul>
        </div>
      </FormBody>
    </>
  );
};

export default FAQ;
